import React, { useRef, useState } from 'react'
import { addMonths } from 'date-fns'
import { Box } from '@chakra-ui/react'
import { FaCalendarDay } from 'react-icons/fa6'

import {
    eqStringFilter,
    gteFloatFilter,
    lteFloatFilter,
    inStringArrFilter,
} from '~utils/query-helpers'
import {
    AppointmentStatus,
    ChatFieldsFragment,
    useQueryAppointmentsQuery,
} from '~graphql/generated/graphql'
import AppointmentDetails from './appointment-details'
import ChatInfoAccordionItem from '../info-accordion-item'
import InfoLoadingPlaceholder from '../info-loading-placeholder'
import AsyncWrapper from '~components/shared/wrappers/async-wrapper'

export default function ChatClientDetailsNextAppointment({
    chat,
}: {
    chat: ChatFieldsFragment
}) {
    const todayRef = useRef(new Date())
    const threeMonthsFromNowRef = useRef(addMonths(todayRef.current, 3))
    const { clinic, client } = chat

    const [isOpen, setIsOpen] = useState(false)

    const { data, loading } = useQueryAppointmentsQuery({
        variables: {
            where: [
                eqStringFilter('clinic', clinic.id),
                eqStringFilter('client', client.id),
                inStringArrFilter('status', [
                    AppointmentStatus.Booked,
                    AppointmentStatus.Confirmed,
                    AppointmentStatus.Pending,
                ]),
                gteFloatFilter('start_time', todayRef.current.getTime()),
                lteFloatFilter(
                    'start_time',
                    threeMonthsFromNowRef.current.getTime(),
                ),
            ],
            page: 0,
            pageSize: 1,
            orderBy: {
                column: 'start_time',
                isAscending: true,
            },
        },
        skip: !clinic || !client || !isOpen,
    })

    const appointment = data?.queryAppointments?.at(0)

    return (
        <ChatInfoAccordionItem
            icon={FaCalendarDay}
            title="Next Appointment"
            isOpenState={isOpen}
            setIsOpenState={setIsOpen}
        >
            <Box px={6} pt={2} pb={3}>
                <AsyncWrapper
                    loading={loading}
                    loadingComponent={<InfoLoadingPlaceholder />}
                >
                    <AppointmentDetails appointment={appointment} />
                </AsyncWrapper>
            </Box>
        </ChatInfoAccordionItem>
    )
}
